/**
 * Preferência de "quais blocos do Dashboard mostrar", só uma
 * conveniência de UI — nunca um dado de negócio. Persistida em
 * `localStorage`, por aba/navegador (não sincroniza entre dispositivos,
 * não precisa: é puramente visual, reversível a qualquer momento pelo
 * próprio botão "Personalizar"). Nenhum bloco desativado deixa de
 * existir — só some da tela até o usuário reativá-lo; os dados por trás
 * continuam sendo os mesmos endpoints reais de sempre.
 */

const CHAVE_ARMAZENAMENTO = 'pg-dashboard-blocos-visiveis-v1';

export interface BlocoDashboard {
  id: string;
  rotulo: string;
}

export const BLOCOS_PERSONALIZAVEIS: BlocoDashboard[] = [
  { id: 'evolucao-financeira', rotulo: 'Evolução financeira' },
  { id: 'pedidos-status', rotulo: 'Distribuição de pedidos' },
  { id: 'bloco-producao', rotulo: 'Produção' },
  { id: 'bloco-estoque', rotulo: 'Estoque' },
  { id: 'bloco-previsao-caixa', rotulo: 'Previsão de caixa' },
  { id: 'bloco-bonus-pg', rotulo: 'Bônus PG' },
  { id: 'origem-vendas', rotulo: 'Origem de vendas por parceiro' },
  { id: 'cupons-mais-usados', rotulo: 'Cupons mais usados' },
  { id: 'heatmap-envios', rotulo: 'Envios despachados' },
  { id: 'pedidos-recentes', rotulo: 'Pedidos recentes' },
  { id: 'clientes-recentes', rotulo: 'Últimos clientes' },
  { id: 'atividades-recentes', rotulo: 'Atividades recentes' },
  { id: 'alertas-importantes', rotulo: 'Alertas importantes' },
  { id: 'integracoes', rotulo: 'Integrações' },
  { id: 'bloco-clientes-resumo', rotulo: 'Clientes & Cupons' },
];

export function carregarBlocosVisiveis(): Set<string> {
  try {
    const bruto = window.localStorage.getItem(CHAVE_ARMAZENAMENTO);
    if (!bruto) return new Set(BLOCOS_PERSONALIZAVEIS.map((b) => b.id));
    const lista: unknown = JSON.parse(bruto);
    if (!Array.isArray(lista)) return new Set(BLOCOS_PERSONALIZAVEIS.map((b) => b.id));
    return new Set(lista.filter((id): id is string => typeof id === 'string'));
  } catch {
    return new Set(BLOCOS_PERSONALIZAVEIS.map((b) => b.id));
  }
}

export function salvarBlocosVisiveis(visiveis: Set<string>): void {
  try {
    window.localStorage.setItem(CHAVE_ARMAZENAMENTO, JSON.stringify([...visiveis]));
  } catch {
    // localStorage indisponível (modo privado/quota) — a preferência
    // simplesmente não persiste entre sessões; nunca quebra a tela por isso.
  }
}
